import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{class:{
    btn: _vm.variant !== 'link',
    [`btn-${_vm.variant}`]: true,
  },attrs:{"to":{ name: _vm.routeName, params: _vm.routeParams },"disabled":_vm.disabled}},[_c('span',{staticClass:"content"},[(!!_vm.icon)?_c(VIcon,{attrs:{"icon":_vm.icon,"size":"sm"}}):_vm._e(),_c('span',{class:{ 'pl-2': !!_vm.icon }},[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }